import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { shouldShowVeloHeader } from '../../../utils';
import { isBranch } from '../../../utils/locationUtils';
import {
  MobileMenuHamburgerIcon,
  VeloLogo,
  WixLogo,
} from '../PageElements/svgs';
import { connectStore } from '../../appContext/StoreProvider/ConnectStore';
import { MenuLogo } from './MenuLogo';
import { MobileHeaderLinksMenu } from './MobileHeaderLinksMenu';
import style from './TopBar.scss';
import { TopBarNavigation } from './TopBarNavigation';
import { withExperiments } from '@wix/wix-experiments-react';

class TopBar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
    };
  }

  static propTypes = {
    toggleMenu: PropTypes.func,
    store: PropTypes.any,
    location: PropTypes.any,
    isPreview: PropTypes.bool,
    onLogoClicked: PropTypes.any,
  };

  toggleMenu = () => {
    this.setState((prevState) => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
    }));
  };

  render() {
    const { isMobileMenuOpen } = this.state;
    const { onLogoClicked, isPreview, store, location } = this.props;

    const showVeloHeader = shouldShowVeloHeader(store.viewer.category);

    return (
      <React.Fragment>
        <MobileHeaderLinksMenu
          isMobileMenuOpen={isMobileMenuOpen}
          isPreview={isPreview}
        />
        <div
          className={classnames({
            [style.topBar]: true,
            [style.withNotificationBar]: isBranch(location) || isPreview,
          })}
        >
          {showVeloHeader ? (
            <>
              <MobileMenuHamburgerIcon
                onClick={this.toggleMenu}
                className={style.mobileMenuButton}
                data-hook="hamburger-menu"
              />
              <VeloHeaderLogo onLogoClicked={onLogoClicked} />
            </>
          ) : (
            <WixInternalHeaderLogo onLogoClicked={onLogoClicked} />
          )}
          <div className={style.linksWrapper}>
            <TopBarNavigation />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withExperiments(withRouter(connectStore(TopBar)));

const VeloHeaderLogo = ({ onLogoClicked }) => (
  <MenuLogo
    onClick={onLogoClicked}
    LogoComponent={VeloLogo}
    classNames={{
      logoContainer: style.veloLogoContainer,
    }}
  />
);

const WixInternalHeaderLogo = ({ onLogoClicked }) => (
  <MenuLogo
    onClick={onLogoClicked}
    primaryText="Docs"
    secondaryText="Internal"
    LogoComponent={WixLogo}
    classNames={{ logo: style.internalLogo }}
  />
);
